<div>
  <div style="text-align: right; color: #000; font-size: 10px; margin-right: 5px">
    {{opacity ==1 ?item.time_actual:''}}
  </div>
  <div class="item" [ngStyle]="{'background-color': color,'opacity':opacity ? opacity : 1}"
       [ngClass]="{'general':item.general}">
    <div class="tipo-title-item">
      {{(item.tipo === 'news-frame' || item.tipo === 'news-frameblock') && item.slot ? 'NEWS (' + item.slot + ')' : type_title}}
    </div>
    <div class="separador-container">
      <div class="line-separador" [ngStyle]="{'border-color': color}"></div>
      <div class="time-box" [ngStyle]="{'color':color,'border-color': color}">{{item.segundos}}
        S.
      </div>
    </div>
    <div class="title-item">
      {{getDisplayName()}}
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/item/item.component.html